import { baseUrl } from "./constants";
import axios from 'axios'; 
import { redirectToProviderWhenUnauthorizedInterceptor } from "./interceptors";

const getHeaders = (token, userId) => {
        return {
        'Content-Type': 'application/json',
        'userid': userId,
        'token': token,
        'Access-Control-Allow-Origin': '*'
        }
    }
const axiosClient = axios.create({
    baseURL: baseUrl
});
redirectToProviderWhenUnauthorizedInterceptor(axiosClient);

export const getHttpResponse = async (url, token, userId) => {
    const headers = getHeaders(token, userId)
    const response = await axiosClient.get(url, {headers});
    return response
}

export const postHttpResponse = async (url, body, token, userId, additionalHeaders = {}) => {
    const headers = { ...getHeaders(token, userId), ...additionalHeaders };
    const response = await axiosClient.post(baseUrl + url, body, {headers});
    return response
}

export const postHttpAuthResponse = async (url, body) => {
    const headers = {'Content-Type': 'application/x-www-form-urlencoded'}
    const response = await axiosClient.post(baseUrl + url, body, {headers});
    return response
}



